import GenericListComponentTanStack from './GenericListComponentTanStack';

export default function AdminCourseChapters() {
  return (
    <GenericListComponentTanStack
      name='courseChapter'
      columns={[
        { accessor: 'order', title: 'Order' },
        { accessor: 'title', title: 'Title' },
        { accessor: 'description', title: 'Description' },
        { accessor: 'video_url', title: 'Url' },
        { accessor: 'duration', title: 'Duration' },
      ]}
    />
  );
}
